:host 
  display: block
  width: 100%
  max-width: 30rem
  margin: 0.5rem auto

  .wrapper
    width: 100%
    height: 0px
    transition: height 0.2s ease-in-out
    overflow: hidden

    .content-wrapper
      margin-bottom: 0.5rem

      &:last-child
        margin-bottom: 0

    .content
      width: 100%
      padding: 0.5rem 2rem
      font-family: var(--ff-manrope)
      font-size: var(--fs-m)
      font-weight: 700
      color: #FFF
      border-radius: 0.4rem
      background-color: #DD2C00
